export const GET_BRANDS = "GET_BRANDS";
export const GET_NEW_ARRIVALS = "GET_NEW_ARRIVALS";
export const GET_BEST_SELLERS = "GET_BEST_SELLERS";
export const GET_MATERIAL = "GET_MATERIAL";
export const GET_MATERIAL_ERR = "GET_MATERIAL_ERR";
export const GET_MATERIALS = "GET_MATERIALS";
export const GET_MATERIALS_ERR = "GET_MATERIALS_ERR";
export const GET_TOP_BRAND_MATERIALS = "GET_TOP_BRAND_MATERIALS";
export const GET_TRENDY_PRODUCTS = "GET_TRENDY_PRODUCTS";
export const SET_FILTER_TOSHOW = "SET_FILTER_TOSHOW";
export const FILTER_MATERIALS = "FILTER_MATERIALS";
export const COUNT_MATERIALS = "COUNT_MATERIALS";
export const SET_SORT = "SET_SORT";
export const SET_PAGE = "SET_PAGE";

export const POST_COMMENT_MATERIAL = "POST_COMMENT_MATERIAL";
export const POST_RATE_MATERIAL = "POST_RATE_MATERIAL";

export const DELETE_COMMENT = "DELETE_COMMENT";
export const GET_COMMENT_ORDER = "GET_COMMENT_ORDER";
export const GET_PROMOTION_SECTION = "GET_PROMOTION_SECTION";
export const GET_PROMOTION_SECTION_1 = "GET_PROMOTION_SECTION_1";
export const GET_PROMOTION_SECTION_2 = "GET_PROMOTION_SECTION_2";
export const GET_PROMOTION_SECTION_3 = "GET_PROMOTION_SECTION_3";
export const GET_PROMOTION_SECTION_4 = "GET_PROMOTION_SECTION_4";
export const GET_PROMOTION_SECTION_5 = "GET_PROMOTION_SECTION_5";
export const GET_PROMOTION_SECTION_6 = "GET_PROMOTION_SECTION_6";
export const GET_PROMOTION_SECTION_7 = "GET_PROMOTION_SECTION_7";
export const GET_PROMOTION_SECTION_8 = "GET_PROMOTION_SECTION_8";
export const GET_PROMOTION_SECTION_9 = "GET_PROMOTION_SECTION_9";
export const GET_PROMOTION_SECTION_10 = "GET_PROMOTION_SECTION_10";

export const TEST_PRO = "TEST_PRO";